import { render, staticRenderFns } from "./AllergenItems.vue?vue&type=template&id=2356021a&scoped=true"
import script from "./AllergenItems.vue?vue&type=script&lang=ts"
export * from "./AllergenItems.vue?vue&type=script&lang=ts"
import style0 from "./AllergenItems.vue?vue&type=style&index=0&id=2356021a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356021a",
  null
  
)

export default component.exports